module.exports = __webpack_public_path__ + "c066c5448562b3ccaefb6408ce4b4ae1.svg";